var vital = "";
const white = "#ffffff";
const black = "#000000";
const red05 = "#faeef0";
const red10 = "#fcdae0";
const red20 = "#eeb9c2";
const red30 = "#e794a4";
const red40 = "#e16a86";
const red55 = "#b83f60";
const red65 = "#902f4a";
const red75 = "#6a2135";
const red85 = "#471321";
const orange05 = "#ffede7";
const orange10 = "#ffdcc4";
const orange20 = "#ffb598";
const orange30 = "#ff8d45";
const orange40 = "#e27200";
const orange55 = "#a85300";
const orange65 = "#843f00";
const orange75 = "#612d00";
const orange85 = "#401c00";
const yellow05 = "#f6f694";
const yellow10 = "#f2e56c";
const yellow20 = "#dfc700";
const yellow30 = "#c5aa00";
const yellow40 = "#ae8d00";
const yellow55 = "#8a6400";
const yellow65 = "#694e00";
const yellow75 = "#533600";
const yellow85 = "#372200";
const cyan05 = "#dff5f8";
const cyan10 = "#aceef5";
const cyan20 = "#8dd2da";
const cyan30 = "#49bac5";
const cyan40 = "#00a0ab";
const cyan55 = "#00767e";
const cyan65 = "#005c62";
const cyan75 = "#004347";
const cyan85 = "#002b2e";
const blue05 = "#ebf1ff";
const blue10 = "#d6e3ff";
const blue20 = "#adc6ff";
const blue30 = "#7cabff";
const blue40 = "#3391ff";
const blue55 = "#006bc6";
const blue65 = "#00529c";
const blue75 = "#003b73";
const blue85 = "#00264e";
const violet05 = "#f1effe";
const violet10 = "#e3dffe";
const violet20 = "#c8bffc";
const violet30 = "#ae9ffb";
const violet40 = "#957ef9";
const violet55 = "#7345f6";
const violet65 = "#5c19e3";
const violet75 = "#4310a9";
const violet85 = "#2b0873";
const gray05 = "#f0f1f4";
const gray10 = "#e0e2e9";
const gray20 = "#c1c6d3";
const gray30 = "#a3abbe";
const gray40 = "#8591a9";
const gray55 = "#626b7d";
const gray65 = "#4b5361";
const gray75 = "#363c47";
const gray85 = "#21262e";
var colors_module = {
  white,
  black,
  red05,
  red10,
  red20,
  red30,
  red40,
  red55,
  red65,
  red75,
  red85,
  orange05,
  orange10,
  orange20,
  orange30,
  orange40,
  orange55,
  orange65,
  orange75,
  orange85,
  yellow05,
  yellow10,
  yellow20,
  yellow30,
  yellow40,
  yellow55,
  yellow65,
  yellow75,
  yellow85,
  cyan05,
  cyan10,
  cyan20,
  cyan30,
  cyan40,
  cyan55,
  cyan65,
  cyan75,
  cyan85,
  blue05,
  blue10,
  blue20,
  blue30,
  blue40,
  blue55,
  blue65,
  blue75,
  blue85,
  violet05,
  violet10,
  violet20,
  violet30,
  violet40,
  violet55,
  violet65,
  violet75,
  violet85,
  gray05,
  gray10,
  gray20,
  gray30,
  gray40,
  gray55,
  gray65,
  gray75,
  gray85
};
var colorPalette = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  white,
  black,
  red05,
  red10,
  red20,
  red30,
  red40,
  red55,
  red65,
  red75,
  red85,
  orange05,
  orange10,
  orange20,
  orange30,
  orange40,
  orange55,
  orange65,
  orange75,
  orange85,
  yellow05,
  yellow10,
  yellow20,
  yellow30,
  yellow40,
  yellow55,
  yellow65,
  yellow75,
  yellow85,
  cyan05,
  cyan10,
  cyan20,
  cyan30,
  cyan40,
  cyan55,
  cyan65,
  cyan75,
  cyan85,
  blue05,
  blue10,
  blue20,
  blue30,
  blue40,
  blue55,
  blue65,
  blue75,
  blue85,
  violet05,
  violet10,
  violet20,
  violet30,
  violet40,
  violet55,
  violet65,
  violet75,
  violet85,
  gray05,
  gray10,
  gray20,
  gray30,
  gray40,
  gray55,
  gray65,
  gray75,
  gray85,
  "default": colors_module
}, Symbol.toStringTag, { value: "Module" }));
const lightGrey = "#e9eef4";
const mediumGrey = "#b3c1d2";
const darkGrey = "#4d6580";
const blue = "#2d80e2";
const blue300 = "#0054af";
const blue500 = "#1f75da";
const blue700 = "#7bb0f4";
const blue800 = "#b4e7fe";
const blue900 = "#e8f6fc";
const violet = "#607bef";
const green = "#1dc6d8";
const orange = "#ffa150";
const orange400 = "#c77221";
const orange600 = "#ffa150";
const orange900 = "#fff0ed";
const red = "#ff5473";
const red400 = "#c61148";
const red600 = "#ff5473";
const red900 = "#ffe0e8";
const cyan300 = "#0b848c";
const cyan500 = "#25c0d1";
const cyan800 = "#aae4ee";
const cyan900 = "#e1f6f9";
const yellow800 = "#fff1be";
const violet300 = "#311e99";
const violet500 = "#5e39e4";
const violet800 = "#c7c2ff";
const violet900 = "#ecebff";
const neutral200 = "#22303f";
const neutral300 = "#364c63";
const neutral400 = "#4d6580";
const neutral600 = "#7a90a8";
const neutral700 = "#b3c1d2";
const neutral800 = "#ccd9e5";
const neutral900 = "#e9eef4";
const pink800 = "#f79eff";
var colors_deprecated_module = {
  lightGrey,
  mediumGrey,
  darkGrey,
  blue,
  blue300,
  blue500,
  blue700,
  blue800,
  blue900,
  violet,
  green,
  orange,
  orange400,
  orange600,
  orange900,
  red,
  red400,
  red600,
  red900,
  cyan300,
  cyan500,
  cyan800,
  cyan900,
  yellow800,
  violet300,
  violet500,
  violet800,
  violet900,
  neutral200,
  neutral300,
  neutral400,
  neutral600,
  neutral700,
  neutral800,
  neutral900,
  pink800
};
const containerPaddingX = "1rem";
const containerWidth = "72.5rem";
const footerHeight = "4.5rem";
var layout_module = {
  containerPaddingX,
  containerWidth,
  footerHeight
};
var layout_module$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  containerPaddingX,
  containerWidth,
  footerHeight,
  "default": layout_module
}, Symbol.toStringTag, { value: "Module" }));
const xs = "380";
const sm = "576";
const md = "768";
const lg = "992";
const xl = "1160";
var breakpoints_module = {
  xs,
  sm,
  md,
  lg,
  xl
};
var breakpoints = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  xs,
  sm,
  md,
  lg,
  xl,
  "default": breakpoints_module
}, Symbol.toStringTag, { value: "Module" }));
const xxSmall = "10";
const xSmall = "10";
const small = "12";
const base = "14";
const basePlus = "15";
const medium = "16";
const mediumExtended = "18";
const large = "20";
const largeExtended = "24";
const almostExtraLarge = "26";
const extraLarge = "28";
const header = "30";
const headerPlus = "32";
const headerMedium = "34";
const headerExtended = "40";
const headerBigger = "52";
const enormous = "60";
var fontSize_module = {
  xxSmall,
  xSmall,
  small,
  base,
  basePlus,
  medium,
  mediumExtended,
  large,
  largeExtended,
  almostExtraLarge,
  extraLarge,
  header,
  headerPlus,
  headerMedium,
  headerExtended,
  headerBigger,
  enormous
};
var fontSize_module$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  xxSmall,
  xSmall,
  small,
  base,
  basePlus,
  medium,
  mediumExtended,
  large,
  largeExtended,
  almostExtraLarge,
  extraLarge,
  header,
  headerPlus,
  headerMedium,
  headerExtended,
  headerBigger,
  enormous,
  "default": fontSize_module
}, Symbol.toStringTag, { value: "Module" }));
const defaultFontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif';
const headerFontFamily = '"DMSans-Bold"';
var fonts_module = {
  defaultFontFamily,
  headerFontFamily
};
const colors = {
  ...colorPalette,
  lightGrey,
  mediumGrey,
  darkGrey,
  blue,
  blue300,
  blue500,
  blue700,
  blue800,
  blue900,
  violet,
  green,
  orange,
  orange400,
  orange600,
  orange900,
  red,
  red400,
  red600,
  red900,
  cyan300,
  cyan500,
  cyan800,
  cyan900,
  yellow800,
  violet300,
  violet500,
  violet800,
  violet900,
  neutral200,
  neutral300,
  neutral400,
  neutral600,
  neutral700,
  neutral800,
  neutral900,
  pink800
};
const breakpointValues = {
  xs: Number.parseInt(xs, 10),
  sm: Number.parseInt(sm, 10),
  md: Number.parseInt(md, 10),
  lg: Number.parseInt(lg, 10),
  xl: Number.parseInt(xl, 10)
};
const createMediaQuery = (rule) => (breakPoint, skipMediaAnnotation) => `${skipMediaAnnotation ? "" : "@media "}only screen and (${rule}: ${breakpoints[breakPoint]}px)`;
const mediaQuery = {
  minWidth: createMediaQuery("min-width"),
  maxWidth: createMediaQuery("max-width"),
  minHeight: createMediaQuery("min-width"),
  maxHeight: createMediaQuery("max-height")
};
export { breakpointValues, breakpoints, colors, defaultFontFamily, fontSize_module$1 as fontSizes, headerFontFamily, layout_module$1 as layout, mediaQuery };
